// extracted by mini-css-extract-plugin
module.exports = {"content":"cd01fbf7b5--content--ynkK7","info":"cd01fbf7b5--info--uP6yG","company":"cd01fbf7b5--company--rYHtO","link":"cd01fbf7b5--link--Xdum1"};